import { IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'
import { IPartnerStatusResponse } from 'legacy/lut/classes/models/partnerStatus'
import PartnerApi from 'legacy/lut/classes/services/api/PartnerApi'
import { handleServiceResponse } from 'legacy/lut/components/widgets/public/profilingTicket/TicketForm/components/referenceData/helpers/handleServiceResponse'
import React, { useEffect, useState } from 'react'

import { ProfilingRequestSource, ProfilingStatus } from 'clickNgo/configs/profiling/common'
import { PartnerStatus } from 'clickNgo/entities/partner/configs'
import { Button } from 'core-components/library/button'
import { Controller } from 'core-components/library/validation'
import logger from 'core/utils/Logger'
import { fail, success } from 'onboarding/classes/services/notification'

import styles from './ReactivateProcessingWindows.module.scss'

interface IProps {
  onClose: () => void
  updateReactivateStatus: (status: PartnerStatus) => void
  locationId?: string
  request?: IRequest
}

export const ReactivateProcessingWindows = ({
  onClose,
  locationId,
  request,
  updateReactivateStatus,
}: IProps) => {
  const [wip, setWip] = useState<boolean>(false)
  const [status, setReactivateStatus] = useState<PartnerStatus | null>(null)
  const [error, setError] = useState<string | null>(null)

  const activate = async (locationId?: string, request?: IRequest) => {
    if (locationId) {
      setWip(true)
      await handleServiceResponse<IPartnerStatusResponse>({
        req: PartnerApi.changePartnerStatus(
          locationId,
          ProfilingStatus.Active,
          request?.PartnerSource || ProfilingRequestSource.ClickAndGo,
          request?.EntryId
        ),
        successAction: (data) => {
          setReactivateStatus(data.partnerStatus || PartnerStatus.New)
          updateReactivateStatus(data.partnerStatus || PartnerStatus.New)
          success('Action successfully performed')
        },
        failAction: (_, error) => {
          setError(error || 'Error to change status')
          fail(error || 'Error to change status')
        },
      })
      setWip(false)
    }
  }

  useEffect(() => {
    activate(locationId, request).catch(logger.error)
  }, [])

  return (
    <>
      <Controller>
        <div style={{ textAlign: 'left', fontWeight: 600 }}>Partner Activation</div>

        {wip ? (
          <div className={styles.spinnerContainer}>
            <div className={styles.spinner}></div>
            <div className={styles.loadingText}>Activating, please wait...</div>
          </div>
        ) : (
          <>
            <div style={{ textAlign: 'left' }}>{error ? error : ''}</div>
            <div style={{ textAlign: 'left' }}>
              {status ? messages?.[status] || 'Unknown Status' : ''}
            </div>

            <div className={styles.buttonGroup}>
              <Button onClick={onClose} className={styles.buttonGroup__cancel} disabled={wip}>
                Ok
              </Button>
            </div>
          </>
        )}
      </Controller>
    </>
  )
}

const messages = {
  [PartnerStatus.Activating]: `The partner has been successfully activated. To continue working with them, please wait for the system synchronization to complete (this usually takes 24 hours)`,
  [PartnerStatus.Compliance]: 'The partner activation is under compliance review',
  [PartnerStatus.Active]: 'The partner has been successfully activated',
}
